<template>
  <div class="plan-edit-menu p-2 text-left text-sm absolute mt-8">
    <ul>
      <li>
        <a v-on:click="$emit('changeVisit')">
          <img src="@/assets/images/icon-menu-time.svg" :alt="$t('hour_label')" />
          <div v-if="isStay(place)">
            <span class="ml-1 text-body">{{ $t('change_arrival_time_and_departure_time') }}</span>
          </div>
          <div v-else>
            <span class="ml-1 text-body">{{ $t('change_arrival_time_and_departure_time') }}</span>
          </div>
        </a>
      </li>
      <li v-if="!place.lock">
        <a v-on:click="$emit('deleteDestination')">
          <img src="@/assets/images/icon-menu-delete.svg" :alt="$t('remove_label')" />
          <span class="ml-1 text-body">{{ $t('remove_destination') }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    place: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    isStay: function(place) {
      return place.genreIds.includes('stay')
    }
  }
}
</script>
